import { TmApiNotFoundError } from '@/core/error/transport/tmApiNotFoundError'

export class TmApiTaskCommentNotFoundError extends TmApiNotFoundError {
  public name = 'TmApiTaskCommentNotFoundError'
}
